import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCircleChevronLeft, 
    faCircleChevronRight, 
    faCircleXmark
  } from '@fortawesome/free-solid-svg-icons';

const ImageGallery = ({images}) => {

    const [slideNumber, setSlideNumber] = useState(0);
    const [openModal, setOpenModal] = useState(false);
    
    const handleOpenModal = (index) => {
        setSlideNumber(index);
        setOpenModal(true);
    }

    const handleCloseModal = () => {
        setOpenModal(false);
    }

    const prevSlide = () => {
        slideNumber === 0
        ? setSlideNumber(images.length - 1)
        : setSlideNumber(slideNumber - 1)
    }

    const nextSlide = () => {
        slideNumber + 1 === images.length
        ? setSlideNumber(0)
        : setSlideNumber(slideNumber + 1)
    }

  return (
    <div>
        {openModal &&
            <div className='sliderWrap'>
                <FontAwesomeIcon icon={faCircleXmark} size='xl' className='btnClose' onClick={handleCloseModal} />
                <FontAwesomeIcon icon={faCircleChevronLeft} size='xl' className='btnPrev' onClick={prevSlide} />
                <FontAwesomeIcon icon={faCircleChevronRight} size='xl' className='btnNext' onClick={nextSlide} />
                <div className='fullScreenImage'>
                    <img src={images[slideNumber].img} alt='...' />
                </div>
            </div>
        }

        <div className='galleryWrap'>
            {
                images && images.map((slide, index) => {
                    return (
                        <div className='single' key={index} onClick={ () => handleOpenModal(index)}>
                            <img className='sneakpeak' src={slide.img} alt='...' />
                        </div> 
                    )
                })
            }
        </div>
    </div>
  )
}

export default ImageGallery;